import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WooCommerceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"woo_commerce"}/>
}
